import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CardAccessComponent, Icons } from '@tecalisdev/infinity';
import { NavigationService } from '../../../shared/services/navigation.service';
import { ViewMediaService } from '../../../shared/services/view-media.service';
import { IOperationDetailResponse, OPERATION_TYPE } from '../../models/operations.models';
import { OperationsHelperService } from '../../services/operations-helper.service';

@Component({
	selector: 'app-operation-detail-cards',
	imports: [CardAccessComponent],
	templateUrl: './operation-detail-cards.component.html',
	styleUrl: './operation-detail-cards.component.scss',
})
export class OperationDetailCardsComponent implements OnInit, OnChanges {
	@Input() detail: IOperationDetailResponse;

	private trans = inject(TranslateService);
	private navigationService = inject(NavigationService);
	private viewMedia = inject(ViewMediaService);
	private operationsHelper = inject(OperationsHelperService);

	public cards = [];

	ngOnInit(): void {
		this.cards = this.updateCards();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['detail']) this.cards = this.updateCards();
	}

	private updateCards(): Array<{
		title: string;
		icon: Icons;
		fn: () => void;
	}> {
		const cards = [
			{
				title: this.trans.instant('OPERATIONS.DETAIL.CARDS.PROCESS'),
				icon: 'icon-list-ticks' as Icons,
				fn: (event?: Event) => {
					if (!this.detail?.process_uuid) return;
					this.navigationService.navigateTo(
						{ routeSegments: ['processes', 'detail', this.detail.process_uuid] },
						event,
					);
				},
			},
		];

		if (this.detail?.identity?.uuid?.trim()) {
			cards.push({
				title: this.trans.instant('OPERATIONS.DETAIL.CARDS.IDENTITY'),
				icon: 'icon-users' as Icons,
				fn: (event?: Event) => {
					if (!this.detail?.identity?.uuid) return;
					this.navigationService.navigateTo(
						{ routeSegments: ['identities', 'detail', this.detail.identity.uuid] },
						event,
					);
				},
			});
		}

		const hasViewableMedia =
			(this.detail?.operation_type_name === OPERATION_TYPE.OCR ||
				this.detail?.operation_type_name === OPERATION_TYPE.POL ||
				this.detail?.operation_type_name === OPERATION_TYPE.DOCUMENTS ||
				this.detail?.operation_type_name === OPERATION_TYPE.CONNECTIONS ||
				this.detail?.operation_type_name === OPERATION_TYPE.FINANCIAL_EVALUATION ||
				this.detail?.operation_type_name === OPERATION_TYPE.EVALUATION) &&
			this.operationsHelper.buildViewMediaForOperationDetailCard(this.detail) !== null;

		if (hasViewableMedia) {
			cards.push({
				title: this.trans.instant('OPERATIONS.DETAIL.CARDS.MEDIA'),
				icon: 'icon-image' as Icons,
				fn: () => {
					this.openMedia();
				},
			});
		}
		return cards;
	}

	private openMedia(): void {
		if (!this.detail) return;
		const payload = this.operationsHelper.buildViewMediaForOperationDetailCard(this.detail);
		if (payload) this.viewMedia.setViewMedia(payload);
	}
}
